import Vue from 'vue';
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {dom} from '@fortawesome/fontawesome-svg-core';
import './custom';
import {
  faPencilAlt,
  faTrash,
  faLock,
  faEnvelope,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faFilter,
  faUser,
  faCheckSquare,
  faImage,
  faCalendar,
  faCalendarCheck,
  faEyeSlash,
  faEye,
  faCaretUp,
  faCaretDown,
  faArrowLeft,
  faToggleOn,
  faToggleOff,
  faUnlock,
  faBan,
  faCheckCircle,
  faUnlockAlt,
  faUserLock,
  faTimes,
  faSave,
  faSearch,
  faFileExcel,
  faFileCsv,
  faFilePdf,
  faPrint,
  faCloudDownloadAlt,
  faCross,
  faCrosshairs,
} from '@fortawesome/free-solid-svg-icons';

Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(
  faPencilAlt,
  faTrash,
  faLock,
  faEnvelope,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faFilter,
  faUser,
  faLock,
  faUnlock,
  faCheckSquare,
  faImage,
  faCalendar,
  faCalendarCheck,
  faEyeSlash,
  faEye,
  faCaretUp,
  faCaretDown,
  faArrowLeft,
  faToggleOn,
  faToggleOff,
  faBan,
  faCheckCircle,
  faUnlock,
  faUnlockAlt,
  faUserLock,
  faTimes,
  faSave,
  faSearch,
  faFileExcel,
  faFileCsv,
  faFilePdf,
  faPrint,
  faCloudDownloadAlt,
  faCrosshairs,
  faTimes,
  faFileCsv,
  faPrint
);
dom.watch(); //enable i tag to svg
